import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import "./style.css";

const menus = [
  {
    id: 0,
    title: "Home",
    link: "/",
  },
  {
    id: 1,
    title: "회사소개",
    link: "#",
    submenu: [
      {
        id: 11,
        title: "엠알메탈로",
        link: "/company-intro",
      },
      {
        id: 12,
        title: "인사말",
        link: "/ceo-message",
      },
      {
        id: 13,
        title: "연혁",
        link: "/history",
      },
    ],
  },
  {
    id: 2,
    title: "사업영역",
    link: "/#",
    submenu: [
      {
        id: 21,
        title: "사업영역",
        link: "/business-area",
      },
      {
        id: 22,
        title: "연구개발",
        link: "/research",
      },
      {
        id: 23,
        title: "특허ㆍ허가",
        link: "/patent",
      },
    ],
  },
  {
    id: 3,
    title: "게시판",
    link: "/board",
  },
  {
    id: 4,
    title: "Contact Us",
    link: "/contact",
  },
  {
    id: 5,
    title: "인재채용",
    link: "/recruitment",
  },
];

const MobileMenu = () => {
  const [openId, setOpenId] = useState(0);
  const [menuActive, setMenuState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(!menuActive)}>
            <i className="ti-close"></i>
          </div>
        </div>

        <ul className="responsivemenu" style={{ margin: "0px" }}>
          {menus.map((item, mn) => {
            return (
              <ListItem
                className={item.id === openId ? "active" : null}
                key={mn}
              >
                {item.submenu ? (
                  <Fragment>
                    <p
                      onClick={() =>
                        setOpenId(item.id === openId ? 0 : item.id)
                      }
                    >
                      {item.title}
                      <i
                        className={
                          item.id === openId
                            ? "fa fa-angle-up"
                            : "fa fa-angle-down"
                        }
                      ></i>
                    </p>
                    <Collapse
                      in={item.id === openId}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List className="subMenu">
                        <Fragment>
                          {item.submenu.map((submenu, i) => {
                            return (
                              <ListItem key={i}>
                                <NavLink
                                  onClick={ClickHandler}
                                  className="active"
                                  to={submenu.link}
                                >
                                  {submenu.title}
                                </NavLink>
                              </ListItem>
                            );
                          })}
                        </Fragment>
                      </List>
                    </Collapse>
                  </Fragment>
                ) : (
                  <NavLink
                    onClick={ClickHandler}
                    className="active"
                    to={item.link}
                  >
                    {item.title}
                  </NavLink>
                )}
              </ListItem>
            );
          })}
        </ul>
      </div>

      <div
        className="showmenu mobail-menu"
        onClick={() => setMenuState(!menuActive)}
      >
        <button type="button" className="navbar-toggler open-btn">
          <span
            className="icon-bar first-angle"
            style={{ backgroundColor: "#0B0056" }}
          ></span>
          <span
            className="icon-bar middle-angle"
            style={{ backgroundColor: "#0B0056" }}
          ></span>
          <span
            className="icon-bar last-angle"
            style={{ backgroundColor: "#0B0056" }}
          ></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
